import { render, staticRenderFns } from "./TransferTicketPopup.vue?vue&type=template&id=34cfbc18"
import script from "./TransferTicketPopup.vue?vue&type=script&lang=js"
export * from "./TransferTicketPopup.vue?vue&type=script&lang=js"
import style0 from "./TransferTicketPopup.vue?vue&type=style&index=0&id=34cfbc18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports